import React, { useState, useRef, useEffect } from 'react';
import { Button, MenuItem, Typography, Box } from '@mui/material';
import { FaUserLarge, FaChevronDown } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import LanguageDropdown from '../../ReusableForm/LanguageDropdown/LanguageDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerById } from '../../../redux/slices/myAccount/customerDataSlice';
const UserMenu = ({ loggedIn, direction, t, onLogout }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customer, loading, error } = useSelector((state) => state.customerData);
  const { isLoggedIn, user, token } = useSelector(state => state.login);
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const buttonRef = useRef(null);
  let timer;
  useEffect(() => {
    if (isLoggedIn && user?.id) {
      // Fetch customer data when logged in and if customer data is not already fetched
      dispatch(getCustomerById({ userId: user.id, token }));
    }
  }, [loggedIn,  user?.id, dispatch]);
  // Handle showing submenu (on mouse enter)
  const handleMouseEnter = (event) => {
    clearTimeout(timer);
    setAnchorEl(event.currentTarget);
    setSubmenuOpen(true);
  };

  // Handle hiding submenu (with a delay)
  const handleMouseLeave = () => {
    timer = setTimeout(() => {
      setSubmenuOpen(false);
      setAnchorEl(null);
    }, 200);
  };

  const handleLoginClick = () => {
    navigate('/signin');
    setAnchorEl(null);
  };

  const handleSignUpClick = () => {
    navigate('/signup');
    setAnchorEl(null);
  };
  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate('/');
  };
  const handleMyAccountClick = () => {
    handleMouseLeave(); // Close submenu
    navigate('/my-account'); // Navigate to the account page
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexDirection: 'row',
        flexWrap: 'nowrap',
        position: 'relative',

      }}

    >
      {/* Language Dropdown */}
      <LanguageDropdown
        styleName="switch"
        style={{
          borderRadius: '14px',
          backgroundColor: 'var(--primary-color)',
          color: 'var(--secondary-color)',
          padding: '8px 16px',
          fontSize: '14px',
          fontWeight: 700,
        }}
      />

      {/* User Menu */}
      <Button
        ref={buttonRef}
        variant="contained"
        sx={{
          backgroundColor: "var(--primary-color)",
          color: "var(--secondary-color)",
          display: 'flex',
          alignItems: 'center',
          borderRadius: "14px",
          fontSize: "14px",
          padding: "13px",
          transition: "all .5s ease",

          lineHeight: "16.41px",
          direction: direction === "rtl" ? 'ltr !important' : 'rtl !important',
          width: "max-content",
          '& .css-1jsm74t-MuiButton-startIcon': {
            display: 'inherit',
            marginRight: direction === 'rtl' ? '8px !important' : '-4px !important',
            marginLeft: direction === 'rtl' ? '-4px !important' : '8px !important',
          },
          '& .css-pyt3b0-MuiButton-endIcon': {
            display: 'inherit',
            marginRight: direction === 'rtl' ? '-4px !important' : '8px !important',
            marginLeft: direction === 'rtl' ? '8px !important' : '-4px !important',
          },
        }}
        onMouseEnter={handleMouseEnter} // Show on hover
        onMouseLeave={handleMouseLeave} // Hide on leave
        startIcon={<FaChevronDown style={{ fontSize: '18px' }} />}
        endIcon={<FaUserLarge style={{ fontSize: '18px' }} />}
      >
        <Typography
          sx={{
            display: { xs: 'none', lg: 'block' },
            fontWeight: 700,
          }}
        >
          {loggedIn && !loading && customer ? customer.customerName : t.profile}
        </Typography>
      </Button>

      {/* User Menu Dropdown */}
      {submenuOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: '100%', // Align below the button
            left: direction === 'ltr' ? '0' : 'auto', // Align to the left for LTR
            right: direction === 'rtl' ? '0' : 'auto', // Align to the right for RTL
            backgroundColor: '#fff',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            zIndex: 1300,
            minWidth: { md: '180px', xs: '150px' },
            width: 'auto',
            display: 'flex',
            flexDirection: 'column',
            marginTop: '9px',
            transition: 'transform 0.3s ease',
            textAlign: direction === 'ltr' ? 'left' : 'right',
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {loggedIn ? (
            <>
              <MenuItem
                onClick={handleMyAccountClick}
                sx={{
                  padding: '8px 16px',
                  color: 'var(--text-color)',
                  textDecoration: 'none',
                  '&:hover': {
                    color: 'var(--secondary-color)',
                    backgroundColor: 'var(--primary-color)',
                  },
                  '&.active': {
                    color: 'var(--secondary-color)',
                    backgroundColor: 'var(--primary-color)',
                  },
                  fontWeight: 700,
                  justifyContent: direction === "ltr" ? "flex-end" : "flex-start"
                }}
              >
                {t.profile}
              </MenuItem>

              <MenuItem
                onClick={handleLogout}
                sx={{
                  padding: '8px 16px',
                  color: '#E22929',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#fff',
                    backgroundColor: '#E22929',
                  },
                  '&.active': {
                    color: '#E22929',
                    backgroundColor: '#fff',
                  },
                  justifyContent: direction === "ltr" ? "flex-end" : "flex-start"
                }}
              >
                {t.logout}
              </MenuItem>
            </>
          ) : (
            <>
              <MenuItem
                onClick={handleLoginClick}
                sx={{
                  padding: '8px 16px',
                  color: 'var(--text-color)',
                  textDecoration: 'none',
                  textAlign: direction === 'ltr' ? 'left' : 'right',
                  '&:hover': {
                    color: 'var(--secondary-color)',
                    backgroundColor: 'var(--primary-color)',
                  },
                  '&.active': {
                    color: 'var(--secondary-color)',
                    backgroundColor: 'var(--primary-color)',
                  },
                  justifyContent: direction === "ltr" ? "flex-end" : "flex-start"
                }}
              >
                {t.signIn}
              </MenuItem>
              <MenuItem
                onClick={handleSignUpClick}
                sx={{
                  padding: '8px 16px',
                  color: 'var(--text-color)',
                  textDecoration: 'none',
                  '&:hover': {
                    color: 'var(--secondary-color)',
                    backgroundColor: 'var(--primary-color)',
                  },
                  '&.active': {
                    color: 'var(--secondary-color)',
                    backgroundColor: 'var(--primary-color)',
                  },

                  justifyContent: direction === "ltr" ? "flex-end" : "flex-start"
                }}
              >
                {t.signUp}
              </MenuItem>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

export default UserMenu;
